const courseIntroActivityRoutes = [
  {
    path: "/course-intro",
    component: () =>
      import(
        /* webpackChunkName: "course-layout-full-width" */ "@/views/course/Layout.vue"
      ),
    children: [
      {
        path: ":id",
        name: "CourseIntroActivityView",
        meta: { title: "View Course Intro" },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "course-intro-activity-view" */ "@/views/course-intro-activity/Intro.vue"
          ),
      },
    ],
  },
]

export default courseIntroActivityRoutes
